import ContentLoader from 'react-content-loader'

export const TableContentLoader = (props: any) => {
  const random = Math.random() * (1 - 0.7) + 0.7
  const height = 18
  return (
    <ContentLoader
      height={430}
      width={1050}
      speed={2}
      foregroundColor="#d9d9d9"
      backgroundColor="#ecebeb"
      {...props}>
      <rect x="3" y="13" rx="6" ry="6" width={70} height={height - 3} />
      <rect x="140" y="13" rx="6" ry="6" width={80} height={height - 3} />
      <rect x="280" y="13" rx="6" ry="6" width={74} height={height - 3} />
      <rect x="630" y="13" rx="6" ry="6" width={80} height={height - 3} />
      <rect x="840" y="13" rx="6" ry="6" width={100} height={height - 3} />
      <rect x="980" y="13" rx="6" ry="6" width={50} height={height - 3} />

      <rect x="3" y={70} rx="6" ry="6" width={110 * random} height={height} />
      <rect x="140" y={70} rx="6" ry="6" width={90 * random} height={height} />
      <rect x="280" y={70} rx="6" ry="6" width={330 * random} height={height} />
      <rect x="630" y={70} rx="6" ry="6" width={186 * random} height={height} />
      <rect x="840" y={70} rx="6" ry="6" width={98 * random} height={height} />
      <rect x="980" y={70} rx="6" ry="6" width={80 * random} height={height} />

      <rect x="3" y={125} rx="6" ry="6" width={125 * random} height={height} />
      <rect x="140" y={125} rx="6" ry="6" width={90 * random} height={height} />
      <rect
        x="280"
        y={125}
        rx="6"
        ry="6"
        width={330 * random}
        height={height}
      />
      <rect
        x="630"
        y={125}
        rx="6"
        ry="6"
        width={186 * random}
        height={height}
      />
      <rect x="840" y={125} rx="6" ry="6" width={98 * random} height={height} />
      <rect x="980" y={125} rx="6" ry="6" width={80 * random} height={height} />

      <rect x="3" y={175} rx="6" ry="6" width={110 * random} height={height} />
      <rect x="140" y={175} rx="6" ry="6" width={90 * random} height={height} />
      <rect
        x="280"
        y={175}
        rx="6"
        ry="6"
        width={330 * random}
        height={height}
      />
      <rect
        x="630"
        y={175}
        rx="6"
        ry="6"
        width={186 * random}
        height={height}
      />
      <rect x="840" y={175} rx="6" ry="6" width={98 * random} height={height} />
      <rect x="980" y={175} rx="6" ry="6" width={80 * random} height={height} />

      <rect x="3" y={220} rx="6" ry="6" width={110 * random} height={height} />
      <rect x="140" y={220} rx="6" ry="6" width={90 * random} height={height} />
      <rect
        x="280"
        y={220}
        rx="6"
        ry="6"
        width={330 * random}
        height={height}
      />
      <rect
        x="630"
        y={220}
        rx="6"
        ry="6"
        width={186 * random}
        height={height}
      />
      <rect x="840" y={220} rx="6" ry="6" width={98 * random} height={height} />
      <rect x="980" y={220} rx="6" ry="6" width={80 * random} height={height} />

      <rect x="3" y={265} rx="6" ry="6" width={110 * random} height={height} />
      <rect x="140" y={265} rx="6" ry="6" width={90 * random} height={height} />
      <rect
        x="280"
        y={265}
        rx="6"
        ry="6"
        width={330 * random}
        height={height}
      />
      <rect
        x="630"
        y={265}
        rx="6"
        ry="6"
        width={186 * random}
        height={height}
      />
      <rect x="840" y={265} rx="6" ry="6" width={98 * random} height={height} />
      <rect x="980" y={265} rx="6" ry="6" width={80 * random} height={height} />

      <rect x="3" y={310} rx="6" ry="6" width={110 * random} height={height} />
      <rect x="140" y={310} rx="6" ry="6" width={90 * random} height={height} />
      <rect
        x="280"
        y={310}
        rx="6"
        ry="6"
        width={330 * random}
        height={height}
      />
      <rect
        x="630"
        y={310}
        rx="6"
        ry="6"
        width={186 * random}
        height={height}
      />
      <rect x="840" y={310} rx="6" ry="6" width={98 * random} height={height} />
      <rect x="980" y={310} rx="6" ry="6" width={80 * random} height={height} />

      <rect x="3" y={365} rx="6" ry="6" width={110 * random} height={height} />
      <rect x="140" y={365} rx="6" ry="6" width={90 * random} height={height} />
      <rect
        x="280"
        y={365}
        rx="6"
        ry="6"
        width={330 * random}
        height={height}
      />
      <rect
        x="630"
        y={365}
        rx="6"
        ry="6"
        width={186 * random}
        height={height}
      />
      <rect x="840" y={365} rx="6" ry="6" width={98 * random} height={height} />
      <rect x="980" y={365} rx="6" ry="6" width={80 * random} height={height} />
    </ContentLoader>
  )
}
